/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Execution_Type_DistanceInputs */

const fr_execution_type_distance = /** @type {(inputs: Execution_Type_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance (m)`)
};

/**

* @param {Execution_Type_DistanceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const execution_type_distance = /** @type {((inputs?: Execution_Type_DistanceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Execution_Type_DistanceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_execution_type_distance(inputs)
});